export default __webpack_public_path__ + "static/media/LogoPos2.7ade448a.png";